<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],

		data () {
			return {
				selected: [],
				data: null,
			}
		},
		created () {
			this.init()
		},
		mounted() {
			this.listening()
		},
		computed: {
			selectAll: {
				get: function () {
					var i = 0;
					var count = 0;
					for (var i = 0; i < this.data.length; i++) {
						var element = this.data[i]
						if (!element['read_at']) {
							count += 1
						}
					}
					return this.data ? this.selected.length == count : false;
				},
				set: function (value) {
					var selected = [];
					if(value) {
						this.data.forEach(function (element) {
							if(!element.read_at) {
								selected.push(element);
							}
						})
					}
					this.selected = selected
				}
			}
		},
		watch: {
			user: function () {
				if(!this.notification) {
					this.getData()
				}
				if(this.user) {
					this.listening()
				}
			}
		},
		methods: {
			init() {
				this.getData()
			},
			listening() {
				if(this.user) {
					var channel = this.$pusher.subscribe(this.$platform.slug + '-notifications-user-'+this.user.id);
					var that = this
					channel.bind('AssignedTask', function(data) {
						that.data.unshift(data)
					})
				}
			},
			getData() {
				if(this.user) {
					this.$http.get('admin/users/'+this.user.id+'/notifications')
						.then(response => {
							this.data = response.body
						}).catch(function(response) {
							console.log(response)
						})
				}
			},
			showNotification(notification) {
				var l = Ladda.create(document.querySelector('#btn-show-notification-'+notification.id))
				l.start()
				var link = notification.data.link
				if(!notification.read_at) {
					var data = {
						notification: notification
					}
					this.$http.post('admin/notifications/read', data)
						.then(response => {
							this.$emit('reload')
							if(link) {
								this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + link)
							}
						}).catch(function(response) {
							console.log(response)
						})
				} else {
					if(link) {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + link)
					}
				}
			},
			markAsRead() {
				var that = this
				if(this.data.length) {
					swal.queue([{
						title: that.$t("messages.attention"),
						text: that.$t("messages.notifications_be_marked_read"),
						type: "warning",
						showCancelButton: true,
						confirmButtonColor: "#53e69d",
						cancelButtonColor: "#ff7676",
						confirmButtonText: "Si",
						cancelButtonText: "No",
						showLoaderOnConfirm: true,
						allowOutsideClick: false,
						preConfirm: function () {
							return new Promise(function (resolve) {
								var data = {
									notifications: that.selected
								}
								that.$http.post('admin/notifications/read', data)
								.then(response => {
									that.$emit('reload')
									that.getData()
									that.selected = []
									swal(response.body.title, response.body.text, response.body.type);
								}).catch(function(response) {
									swal({
										title: response.statusText,
										text: response.body,
										type: "warning"
									});
								})
							})
						}
					}]).catch(swal.noop)
				}
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/notifications/views/Index.vue